import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {MappableProcessType, PROCESS_MANAGEMENT_ITEM_TYPE_TO_READABLE} from 'processes/ProcessConstants';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';
import strUtil from 'util/strUtil';

import {SchemaInfo} from './FieldMappingConstants';

const HEADER_TEXT = "from source schema's task or output";

export default function MapperSourceTable(props: {
  disabled?: boolean;
  fromSchemaInfos: Array<SchemaInfo>;
  onChangeFromItemType: (itemType: MappableProcessType, idx: number) => void;
}): JSX.Element {
  assert(props.fromSchemaInfos.length > 0, 'Expected at least one source schema');

  return (
    <div className={css(styles.fromItemSection)}>
      <div className={css(styles.modalText)}>
        {`${props.disabled ? 'Mapping ' : 'Choose to map'} ${HEADER_TEXT}`}
      </div>
      <Table numRows={props.fromSchemaInfos.length}>
        <Column
          header="Source schema"
          renderCell={(rowIndex) => <Cell>{props.fromSchemaInfos[rowIndex].taskSchema.name}</Cell>}
        />
        <Column
          header={props.disabled ? 'Mapping from' : 'Map from'}
          renderCell={(rowIndex) => (
            <Cell>
              <SelectDropdown
                dataTestAttrs={{
                  component: 'MapperSourceTable',
                  element: 'mapperSourceDropdown',
                  key: props.fromSchemaInfos[rowIndex].taskSchema.id,
                  index: `${rowIndex}`,
                }}
                disabled={Boolean(props.disabled || !props.fromSchemaInfos[rowIndex].canChangeItemType)}
                className={css(styles.sourceDropdown)}
                displayName={strUtil.toSentenceCase(
                  PROCESS_MANAGEMENT_ITEM_TYPE_TO_READABLE[props.fromSchemaInfos[rowIndex].itemType]
                )}
                menu={
                  <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
                    {[ModelTypeConstants.PROCESS_TASK, ModelTypeConstants.PROCESS_OUTPUT].map(
                      (itemType: MappableProcessType) => (
                        <Option
                          key={itemType}
                          value={itemType}
                          onSelect={(selectedValue: MappableProcessType) => {
                            props.onChangeFromItemType(selectedValue, rowIndex);
                          }}
                        >
                          {strUtil.toSentenceCase(PROCESS_MANAGEMENT_ITEM_TYPE_TO_READABLE[itemType])}
                        </Option>
                      )
                    )}
                  </Menu>
                }
              />
            </Cell>
          )}
        />
      </Table>
    </div>
  );
}

const styles = StyleSheet.create({
  sourceDropdown: {flex: 0.33},
  fromItemSection: {paddingTop: 22},
  modalText: {
    ...FONT_PROXIMA_13,
    paddingBottom: 16,
    paddingLeft: 6,
  },
});
